module.exports = __webpack_public_path__ + "static/thotcon-mindwave-14eb8805080b3c8f09e0dcdc7b071d7e.png";